export default "__VITE_ASSET__724F5et2__"